module.exports = __webpack_public_path__ + "img/icon_sm_sjgl.ae72162a.png";